import { POSTFORM, POST, GET } from '@/utils/request'
import Api from './url'
export const getNoticeList = async (params: object) => {
  return await GET({ url: Api.getNoticeList, params, showError: false })
}
